#import "@/apollo/fragments/Comment.gql"

mutation UpdateQAAnnotationCommentOnComputedDeliverable($commentId: ID!, $content: String!, $mentions: [String]) {
    updateQAAnnotationCommentOnComputedDeliverable(commentId: $commentId, content: $content, mentions: $mentions) {
        ...Comment
    }
}
